import { BadRequestError } from '../lib/APIClient';
import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';

const BacsService = {
    async validate(sortCode, accountNumber) {
        try {
            const data = { sortCode, accountNumber };
            await AuthenticatedAPIClient.get('/customers/validation/bacs-lookup', data);
            return true;
        } catch (e) {
            if (e instanceof BadRequestError) {
                return false;
            }
            throw e;
        }
    }
};

export default BacsService;



// WEBPACK FOOTER //
// ./src/services/BacsServices.js